import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DocumentsUploadTransitionsComponent from './DocumentsUploadTransitionsComponent';
import { DOC_ATTACHMENT_STATE_TRANSITIONS_QUERY } from '../queries';
import { useQueryWithErrorHandling } from 'customHooks/errorHandling';
import { FakeText } from '@totalsoft/rocket-ui';

const DocumentsUploadTransitionsContainer = ({ documentAttachmentId }) => {
  const [localStateTransitions, setLocalStateTransitions] = useState([]);
  const { data, loading } = useQueryWithErrorHandling(DOC_ATTACHMENT_STATE_TRANSITIONS_QUERY, {
    variables: { documentAttachmentId },
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    if (!loading && data?.getDocAttachmentStateTransitions) {
      setLocalStateTransitions(data.getDocAttachmentStateTransitions);
    }
  }, [loading, data]);

  if (loading) return <FakeText lines={6} />;

  return <DocumentsUploadTransitionsComponent stateTransitions={localStateTransitions} />;
};

DocumentsUploadTransitionsContainer.propTypes = {
  documentAttachmentId: PropTypes.number.isRequired
};

export default DocumentsUploadTransitionsContainer;
